import { $UserAddPermissions, ACTIONS } from "@store/user-store";
import React from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import { PageTabPropsT } from "@interfaces/common";

import { TabItems } from "@components/common";
import styles from "@scss/pages/study-center.module.scss";
import { useUnit } from "effector-react";

import DocumentTemplatesPage from "@pages/document-templates-page/document-templates-page";
import { DocumentTemplatesArchive } from "@feature/document-templates-archive";
import Responsibility from "@pages/responsibility";
import LegalInformation from "@pages/legal-information";

const AdditionalRoutes = () => {
  const permissions = useUnit($UserAddPermissions);

  const TAB_ITEMS: PageTabPropsT[] = [
    {
      path: "/additional/responsibility",
      label: "Ответственность",
    },
    {
      path: "/additional/legal-information",
      label: "Юридическая информация",
    },
  ];

  if (
    permissions.hasPermission(ACTIONS.companyDocumentTemplates_allowedToShow)
  ) {
    TAB_ITEMS.unshift({
      path: "/additional/document-templates",
      label: "Шаблоны документов",
    });
  }

  return (
    <div className={styles.StudyCenter}>
      <div className={styles.StudyCenter__panel}>
        <TabItems items={TAB_ITEMS} />
        <Routes>
          <Route path={"/"} element={
            permissions.hasPermission(ACTIONS.companyDocumentTemplates_allowedToShow) ? (
              <Navigate to="/additional/document-templates" />
            ) : (
              <Navigate to="/additional/responsibility" />
            )} />
          <Route path={"/document-templates"} Component={DocumentTemplatesPage} />
          <Route path={"/document-templates/archive"} Component={DocumentTemplatesArchive} />
          <Route path={"/responsibility"} Component={Responsibility} />
          <Route path={"/legal-information"} Component={LegalInformation} />
        </Routes>
      </div>
    </div>
  );
};

export default AdditionalRoutes;
